import { App as GysMap } from '@cfm-media/get-your-spot-ui/src/App.jsx';
import { RootStoreModel as MapStoreModel } from '@cfm-media/get-your-spot-ui/src/stores';
import { observer } from 'mobx-react-lite';

import { LoadSpinner } from '../components/loader';
import { PageWrapper } from '../components/page-wrapper';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';
import { useHotelPoi } from '../hooks/useHotelPoi';
import { LoadableStatus } from '../mobx-utils';

export const Map = observer(() => {
  const { BookingStore } = useStore();
  const { booking } = BookingStore;
  const hotelPoi = useHotelPoi();

  if (booking.status !== LoadableStatus.done) {
    return <LoadSpinner />;
  }
  console.log(hotelPoi);
  const MapStore = MapStoreModel.create({
    config: {
      gysService: {
        ownerId: booking?.data?.id,
        url: `api`,
        language: 'de',
        useMock: false,
      },
      initialPosition: {
        longitude:
          booking?.data?.hotels?.[0]?.geoData?.longitude ?? 3.709001339109534,
        latitude:
          booking?.data?.hotels?.[0]?.geoData?.latitude ?? 40.391556239204505,
      },
      mapBox: {
        accessToken:
          'pk.eyJ1IjoiYmVudG91cml0IiwiYSI6ImNsNzRvM21wNjA2eDczbnA2cHUzNjg3N3YifQ.v1cVdHFuoEmY8Bfid-UMOA',
        styleUrl: 'mapbox://styles/bentourit/cl7fxckxn000n15s01yc4c6o9',
      },
      translationUrl: '',
    },
    poi: {
      list: [],
    },
    categories: {},
    favourites: {
      list: [],
    },
    layers: {},
    user: { position: null },
    search: {
      distancesKm: {
        small: 5000,
        medium: 10000,
        large: 50000,
        infinite: 4000000,
      },
    },
    parking: {},
    myLocations: {
      list: hotelPoi ? [hotelPoi] : [],
      errors: {
        alreadyExists: false,
        description: false,
        title: false,
      },
    },
  });

  return (
    <PageWrapper>
      <GysMap store={MapStore} translateHook={useTranslation} />
    </PageWrapper>
  );
});
